import { render, staticRenderFns } from "./grid-item.vue?vue&type=template&id=c6c6b4e2"
import script from "./grid-item.vue?vue&type=script&lang=ts"
export * from "./grid-item.vue?vue&type=script&lang=ts"
import style0 from "./grid-item.vue?vue&type=style&index=0&id=c6c6b4e2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c6b4e2')) {
      api.createRecord('c6c6b4e2', component.options)
    } else {
      api.reload('c6c6b4e2', component.options)
    }
    module.hot.accept("./grid-item.vue?vue&type=template&id=c6c6b4e2", function () {
      api.rerender('c6c6b4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/grid-item.vue"
export default component.exports